import { CircularProgress, Container } from '@mui/material';

export const InitialLoading = () => {
    return (
        <Container sx={{ textAlign: 'center', mt: 10 }}>
            <CircularProgress color="success" />
        </Container>
    );
};
